export type ThemeType = typeof theme; // This is the type definition for my theme object.

export const theme = {
  profileNavItemColor: "white",
  profileNavItemBgolor: "white",
  profileNavItemActiveColor: "white",
  profileNavItemActiveColorText: "black",
  profileSettingColor:"#fff",
  space: [
    "0.25rem",
    "0.5rem",
    "0.75rem",
    "1rem",
    "1.5rem",
    "2rem",
    "3rem",
    "4rem",
    "6rem",
    "8rem",
    "12rem",
    "16rem",
    "24rem",
  ],
 
  select:{
    arrowColor:"#000"
  }
 ,
  card:{
    priceSelectBg:"#fff",
    priceSelectText:"#000",

  }

};

// const theme = light; // set the light theme as the default.
export default theme;
